"use client";
import { useState } from "react";
import { Card } from "../card";
import { Flex, Text } from "@chakra-ui/react";
import { ImageFragment } from "@ui/post";
import { colors } from "@areahub/theme";

export interface HoverCardProps {
  id: string;
  bg?: string;
  label?: string;
  description?: string;
  hoverDescription?: string;
  icon?: ImageFragment & {
    alt: string;
  };
  textColor?: string;
  url?: string;
}

export const HoverCard = ({
  description,
  hoverDescription,
  textColor,
  bg,
}: HoverCardProps) => {
  const [onHover, setOnHover] = useState(false);
  return (
    <Card
      height={{
        base: "180px",
        md: "200px",
        lg: "240px",
        xl: "250px",
      }}
      w={{
        base: "full",
        md: "80%",
      }}
      bgColor={bg || "white"}
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
      borderRadius={"xl"}
      shadow={"lg"}
      overflow="hidden"
    >
      <Flex
        position="relative"
        alignItems={"center"}
        justifyContent={"center"}
        h="full"
        px={{ base: 6, lg: 8 }}
      >
        <Text
          position="absolute"
          left={0}
          right={0}
          px={{ base: 6, lg: 8 }}
          color={textColor || colors.enterpriseColors.blue["500"]}
          fontWeight={"bold"}
          fontSize={{
            lg: 19,
            xl: 22,
          }}
          textAlign={"center"}
          opacity={onHover ? 0 : 1}
          visibility={onHover ? "hidden" : "visible"}
          transform={onHover ? "translateY(-10px)" : "translateY(0)"}
          transition={
            "opacity 0.3s ease-in-out, visibility 0s linear 0.3s, transform 0.3s ease-in-out"
          }
          wordBreak="normal"
          overflowWrap="normal"
        >
          {description}
        </Text>
        <Text
          position="absolute"
          left={0}
          right={0}
          px={{ base: 6, lg: 8 }}
          color={textColor || colors.enterpriseColors.blue["500"]}
          fontWeight={"bold"}
          fontSize={{
            lg: 16,
            xl: 18,
          }}
          textAlign={"center"}
          opacity={onHover ? 1 : 0}
          visibility={onHover ? "visible" : "hidden"}
          transform={onHover ? "translateY(0)" : "translateY(10px)"}
          transition={
            "opacity 0.3s ease-in-out, visibility 0s linear 0.3s, transform 0.3s ease-in-out"
          }
          wordBreak="normal"
          overflowWrap="normal"
        >
          {hoverDescription}
        </Text>
      </Flex>
    </Card>
  );
};
